import React, { useEffect, useState } from "react";
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineDot,
  TimelineContent,
} from "@mui/lab";
import "./experienceSection.css";
import { getRoleLabel } from "../../../helpers/stringHelper";

const ExperienceSection = ({ userId }) => {
  const [workHistory, setWorkHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchWorkHistory = async () => {
      try {
        const response = await fetch(
          `/api/attorney/webapp/fetchExperienceData?userId=${encodeURIComponent(
            userId
          )}`,
          {
            method: "GET",
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch work history");
        }

        const data = await response.json();
        setWorkHistory(data);
      } catch (error) {
        console.error("Error fetching work history:", error);
      } finally {
        setLoading(false);
      }
    };

    if (userId) {
      fetchWorkHistory();
    }
  }, [userId]);

  if (loading) {
    return <div className="experience-section-loading">Loading...</div>;
  }

  return (
    <div className="experience-section-container">
      <div className="work-experience-container">
        <p className="experience-inner-title">Work Experience</p>
        <Timeline
          align="left"
          sx={{
            "& .MuiTimelineItem-root:before": {
              flex: 0,
            },
          }}
        >
          {workHistory && workHistory.length > 0 ? (
            workHistory.map((item) => {
              const {
                id,
                firm_name,
                position,
                start_year,
                end_year,
                description,
                present,
              } = item;

              // Format the date range based on whether the role is current
              const dateRange = present
                ? `${start_year} – Present`
                : `${start_year} – ${end_year}`;

              return (
                <TimelineItem key={id}>
                  <TimelineSeparator>
                    <TimelineDot color={present ? "primary" : "grey"} />
                    <div className="timeline-line" />
                  </TimelineSeparator>
                  <TimelineContent>
                    <div className="experience-section-job-item">
                      <p className="experience-section-year-range">
                        {dateRange}
                      </p>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          textAlign: "left",
                          marginLeft: "auto",
                          width: "60%",
                        }}
                      >
                        <p className="experience-section-position">
                          {getRoleLabel(position)},{" "}
                          <span className="experience-section-firm">
                            {firm_name}
                          </span>
                        </p>
                        <p className="experience-section-description">
                          {description}
                        </p>
                      </div>
                    </div>
                  </TimelineContent>
                </TimelineItem>
              );
            })
          ) : (
            // Render a placeholder timeline item when no work history is available
            <TimelineItem>
              <TimelineSeparator>
                <TimelineDot color="grey" />
                <div className="timeline-line" />
              </TimelineSeparator>
              <TimelineContent>
                <div className="experience-section-job-item">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      textAlign: "left",
                      marginLeft: "auto",
                      width: "60%",
                    }}
                  >
                    <p className="experience-section-position">
                      No work history found.
                    </p>
                    <p className="experience-section-description">
                      {/* Optionally, add more placeholder text here */}
                    </p>
                  </div>
                </div>
              </TimelineContent>
            </TimelineItem>
          )}
        </Timeline>
      </div>
    </div>
  );
};

export default ExperienceSection;
